// Consent state for privacy-conscious analytics.
// Stored in localStorage under `arq_consent`. Non-essential tracking only runs
// once the visitor grants analytics consent (or DNT/GPC is off and they accept).

const KEY = "arq_consent";
const listeners = new Set();

export function hasSignal() {
  // Global Privacy Control / Do Not Track — treat as an explicit "reject".
  try {
    if (navigator.globalPrivacyControl === true) return true;
    const dnt = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
    if (dnt === "1" || dnt === 1 || dnt === "yes") return true;
  } catch (_e) { /* ignore */ }
  return false;
}

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch (_e) { /* ignore */ }
  // No decision yet. If a privacy signal is present, default to reject.
  return { decided: false, essential: true, analytics: false, marketing: false, signal: hasSignal() };
}

export function setConsent(next) {
  const value = {
    decided: true,
    essential: true,
    analytics: !!next.analytics,
    marketing: !!next.marketing,
    ts: new Date().toISOString(),
  };
  try { localStorage.setItem(KEY, JSON.stringify(value)); } catch (_e) { /* ignore */ }
  listeners.forEach((fn) => { try { fn(value); } catch (_e) { /* ignore */ } });
  return value;
}

export function acceptAll() {
  return setConsent({ analytics: true, marketing: true });
}

export function rejectNonEssential() {
  return setConsent({ analytics: false, marketing: false });
}

export function onConsentChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function analyticsAllowed() {
  return !!getConsent().analytics;
}
